import React from 'react';
import PropTypes from 'prop-types';
import { Input, InputAnimate } from './FieldText.style';

class InputInner extends React.PureComponent {
  static propTypes = {
    focusOnMount: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.Input = null;

    this.setTextInputRef = element => {
      this.Input = element;
    };

    this.focusTextInput = () => {
      // Focus the text input using the raw DOM API
      if (this.Input) this.Input.focus();
    };
  }

  componentDidMount() {
    // autofocus the input on mount
    if (this.props.focusOnMount) {
      this.focusTextInput();
    }
  }

  render() {
    return (
      <InputAnimate>
        <Input innerRef={this.setTextInputRef} {...this.props} />
      </InputAnimate>
    );
  }
}

export default InputInner;
